export default __webpack_public_path__ + "static/media/slider_image_02-sm@1x.d21abfe2.jpg";